module.exports = __webpack_public_path__ + "assets/cb0d09a749c45a4d3ee2acee6fd72d66.svg";